module.exports = {"addAp":{"type":"mini","content":[{"sub":"Add the first AirPulse to this floor","body":""}],"title":"addAp"},"warn":{"type":"mini","content":[{"sub":"{warn} <span style='color:yellow'>Warning</span> Alerts Present","body":""}],"title":"warn"},"crit":{"type":"mini","content":[{"sub":"{crit} <span style='color:red'>Critical</span> Alerts Present","body":""}],"title":"crit"},"good":{"type":"mini","content":[{"sub":"No Alerts Present","body":""}],"title":"good"},"delBldg":{"type":"mini","content":[{"sub":"Permanent!","body":""}],"title":"delBldg"}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/hoverTemplates/Building.json
// module id = 406
// module chunks = 1